import { EFrekvenceVyplaty } from 'enums/isin/udaje/frekvenceVyplaty';

const frekvenceVyplatySelect = [
    {
        value: EFrekvenceVyplaty.A,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_A'
    },
    {
        value: EFrekvenceVyplaty.S,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_S'
    },
    {
        value: EFrekvenceVyplaty.Q,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_Q'
    },
    {
        value: EFrekvenceVyplaty.M,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_M'
    },
    {
        value: EFrekvenceVyplaty.W,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_W'
    },
    {
        value: EFrekvenceVyplaty.D,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_D'
    },
    {
        value: EFrekvenceVyplaty.B,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_B'
    },
    {
        value: EFrekvenceVyplaty.X,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_X'
    },
    {
        value: EFrekvenceVyplaty.NA,
        labelcz: 'ISIN_EMISE_DLUHOPIS_FREKVENCE_NA'
    }
];

export default frekvenceVyplatySelect;
